/* eslint-env jquery */

"use strict";

(function () {
    // eslint-disable-next-line no-unused-vars
    $(".video-tile-button").on("click", function (ev) {
        var video = document.getElementById("myVideo");

        // Get the button
        var btn = document.getElementById("video-play-btn");
        if (video.paused) {
            video.play();
            btn.innerHTML =
                // eslint-disable-next-line
                '<svg xmlns="http://www.w3.org/2000/svg" fill="white" viewBox="0 0 24 24" stroke-width="2" stroke="white" height="32px" width="32px"><path fill="white" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" d="M15.75 5.25v13.5m-7.5-13.5v13.5" /></svg>';
        } else {
            video.pause();
            btn.innerHTML =
                // eslint-disable-next-line
                '<svg xmlns="http://www.w3.org/2000/svg" fill="white" viewBox="0 0 24 24" stroke-width="2" stroke="white" height="32px" width="32px"><path fill="white" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" d="M5.25 5.653c0-.856.917-1.398 1.667-.986l11.54 6.348a1.125 1.125 0 010 1.971l-11.54 6.347a1.125 1.125 0 01-1.667-.985V5.653z" /></svg>';
        }
    });
})();
